module.exports = __webpack_public_path__ + "media/images/pillar_seo-4c7209bbaa8b824367e02312c2ff6b6a.jpg";